import { GraphiQL, GraphiQLInterface } from './components/GraphiQL';
export { GraphiQL, GraphiQLInterface };
export { GraphiQLProvider } from '@graphiql/react';
export default GraphiQL;
//# sourceMappingURL=index.js.map